import React, { useState } from 'react'
import logo from '../assets/images/Logo.png'
import userimg from '../assets/images/images.png'
const Navbar = () => {
    const [isDivVisible, setIsDivVisible] = useState(false);
    const toggleDiv = () => {
        setIsDivVisible((prevState) => !prevState);
    };
    return (
        <div style={{ backgroundColor: "#F2F8FE" }}>
            <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-navbar py-2 px-4 px-lg-5">
                <a href="/aboutUs" className="navbar-brand d-flex align-items-center">
                    <h2 className="m-0 text-primary">
                        <img className="img-fluid me-2" src={logo} alt="" style={{ width: "150px" }} />
                    </h2>
                </a>
                <button
                    type="button"
                    className="navbar-toggler"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto py-4 py-lg-0">
                        <a href="/home" className="nav-item nav-link active">Home</a>
                        <a href="/myProfile" className="nav-item nav-link">My Profile</a>
                    </div>

                    {/* Desktop View: Profile Dropdown */}
                    <div className="h-100 d-none d-lg-inline-flex align-items-center ms-lg-3">
                        <i className="fa-regular fa-bell me-3"></i>
                        <div className="dropdown">
                            <img src={userimg} className="dropbtn" alt="User Profile" />
                            <div className="dropdown-content">
                                <a href="/myProfile">
                                    <i className="fa-regular fa-user me-2"></i> My Profile
                                </a>
                                <a href="/">
                                    <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Mobile View: Separate Logout Button */}
                    <div className="w-50 d-lg-none text-center mb-3">
                        <a href="/" className="btn btn-danger w-100">
                            <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
                        </a>
                    </div>
                </div>
            </nav>
        </div>

    )
}

export default Navbar
